/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChangePasswordCommand
 */
export interface ChangePasswordCommand {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordCommand
     */
    password: string;
}

/**
 * Check if a given object implements the ChangePasswordCommand interface.
 */
export function instanceOfChangePasswordCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "password" in value;

    return isInstance;
}

export function ChangePasswordCommandFromJSON(json: any): ChangePasswordCommand {
    return ChangePasswordCommandFromJSONTyped(json, false);
}

export function ChangePasswordCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangePasswordCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'password': json['password'],
    };
}

export function ChangePasswordCommandToJSON(value?: ChangePasswordCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'password': value.password,
    };
}

